<nav class="d-none d-sm-block navbar bg-dark text-white fixed-bottom">
  <div class="d-flex justify-content-between w-100">
    <div><span class="copyright mr-2">&copy;</span>{{ year }} Timothy Blue</div>
    <div class="version d-flex align-items-center">Version: {{ versionInfo | async }}</div>
  </div>
</nav>
